<!-- @prettier -->
<template>
  <div class="actions-collapsed-list">
    <button
      class="btn btn-function exit-collapsed-list"
      :disabled="disabled"
      @click="collapseActions"
    >
      <i
        v-tooltip.right.hover="$t('CANCEL')"
        class="glyphicon glyphicon-chevron-left"
        aria-hidden="true"
      />
    </button>

    <!-- Edit action -->
    <div
      v-if="createAccess"
      class="action-icon"
    >
      <button
        class="btn btn-list-function"
        :href="href"
        :disabled="currentPublisher.isSelf"
        @click="showForm"
      >
        <i
          v-tooltip.right.hover="$t('PUBLISHERS_ACTIONS_I_EDIT_ALT')"
          class="typcn typcn-edit"
          aria-hidden="true"
        />
        <span
          v-t="'PUBLISHERS_ACTIONS_I_EDIT_ALT'"
          class="hint-text-mobile"
        />
      </button>
    </div>

    <!-- manage invites action -->
    <div class="action-icon">
      <button
        :disabled="disabled"
        class="btn btn-list-function"
        @click="showInvites"
      >
        <i
          v-tooltip.right.hover="$t('MANAGE_USER_INVITES')"
          class="fa m-t-4 fa-user-plus"
          aria-hidden="true"
        />
        <span
          v-t="'MANAGE_USER_INVITES'"
          class="hint-text-mobile"
        />
      </button>
    </div>


    <!-- view reports action -->
    <div class="action-icon">
      <button
        class="btn btn-list-function"
        :disabled="disabled"
        @click="viewReport"
      >
        <i
          v-tooltip.left.hover="$t('PUBLISHERS_ACTIONS_REPORTING')"
          class="typcn typcn-chart-pie"
        />

        <span
          v-t="'PUBLISHERS_ACTIONS_REPORTING'"
          class="hint-text-mobile"
        />
      </button>
    </div>

    <!-- pause action -->
    <div
      v-if="currentPublisher.enabled"
      class="action-icon"
      :disabled="disabled"
    >
      <button
        class="btn btn-list-function"
        :disabled="disabled || currentPublisher.isSelf"
        @click="confirmPause"
      >
        <i
          v-tooltip.right.hover="$t('PUBLISHERS_ACTIONS_PAUSE')"
          class="typcn typcn-media-pause"
        />

        <span
          v-t="'PUBLISHERS_ACTIONS_PAUSE'"
          class="hint-text-mobile"
        />
      </button>
    </div>

    <!-- set status action -->
    <div
      v-if="!currentPublisher.enabled"
      class="action-icon"
    >
      <button
        class="btn btn-list-function"
        :disabled="disabled || currentPublisher.isSelf"
        @click="setStatus"
      >
        <i
          v-tooltip.right.hover="$t('PUBLISHERS_ACTIONS_ENABLE')"
          class="typcn typcn-media-play"
        />

        <span
          v-t="'PUBLISHERS_ACTIONS_ENABLE'"
          class="hint-text-mobile"
        />
      </button>
    </div>

    <div class="action-icon">
      <button
        :disabled="disabled || currentPublisher.isSelf"
        class="btn btn-list-function"
        @click="confirmDelete"
      >
        <i
          v-tooltip.right.hover="$t('PUBLISHERS_ACTIONS_DELETE')"
          class="typcn typcn-trash"
          aria-hidden="true"
        />
        <span
          v-t="'PUBLISHERS_ACTIONS_DELETE'"
          class="hint-text-mobile"
        />
      </button>
    </div>

    <!-- show references-->
    <div class="action-icon">
      <button
        :disabled="disabled"
        class="btn btn-list-function"
        @click="showPublisherReferences"
      >
        <i
          v-tooltip.bottom.hover="$t('SHOW_REFERENCES')"
          class="typcn typcn-flow-children"
          aria-hidden="true"
        />
        <span
          v-t="'SHOW_REFERENCES'"
          class="hint-text-mobile"
        />
      </button>
    </div>

    
    <ChangeLogObjectButtonAction
      :is-disabled="disabled"
      :object-id="currentPublisher.id"
      :object-name="currentPublisher.name"
      object-type="publisher"
    />
  </div>
</template>

<script>
import ChangeLogObjectButtonAction from '@/core/components/ChangeLog/ChangeLogObjectButtonAction';
import messages from '../locales';
import sharedMessages from '@/core/locales';
import { accountsService } from '@/angularBridgeCode/ringbaPortal.servicesModule';

export default {
  name: 'PublisherActions',
  components: {
    ChangeLogObjectButtonAction
  },
  props: {
    createAccess: {
      type: Boolean,
      default: false
    },
    currentPublisher: {
      type: Object,
      default() {
        return {};
      }
    },
    isAdmin: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    href: {
      type: String,
      default: ''
    }
  },
  computed: {
    currentUserName() {
      return accountsService.currentUserName;
    },
  },
  methods: {
    viewReport() {
      //@TODO: We should be using vue router here and doing $router.push - will come back after removing angular
      window.location.replace(`/#/dashboard/call-logs?filterkey=affiliateName&filterdisplay=Affiliate&filtervalue=${encodeURIComponent(this.currentPublisher.name)}&filterisgroup=true`);
    },
    confirmDelete() {
      if (!this.disabled && !this.currentPublisher.isSelf) {
        this.$emit('confirm-delete', this.currentPublisher);
      }
    },
    confirmPause() {
      if (!this.disabled) {
        this.$emit('confirm-pause', this.currentPublisher);
      }
    },
    showPublisherReferences() {
      this.$emit('show-publisher-references', this.currentPublisher);
    },
    setStatus() {
      if (!this.disabled) {
        this.$emit('set-status', this.currentPublisher, true);
      }
    },
    showForm(e) {
      e.preventDefault();

      this.$emit('show-edit-form', this.currentPublisher);
    },
    showInvites() {
      if (this.disabledInvites) {
        return;
      }
      this.$emit('show-invites', this.currentPublisher);
    },
    collapseActions() {
      this.$emit('collapse-actions', this.currentPublisher);
    }
  },
  i18n: {
    messages,
    sharedMessages,
    locale: 'en'
  }
};
</script>

<style lang="scss"></style>
